module.exports = __webpack_public_path__ + "static/media/IconExamScience.b0d357e6.svg";